import * as React from 'react';
import styled from '@emotion/styled';
import { PHONE_MEDIA } from '../vars';
import { buildDocsNavigationTree } from '../pages/docs/shared/docs';
import { DocsTopicSectionWidget, docsTopicSectionId } from './DocsTopicSectionWidget';

export interface ProductDocsWidgetProps {
  title: string;
  description: string;
  topics: [string, ...string[]];
}

const sections = buildDocsNavigationTree('/docs/topics/');

export const ProductDocsWidget: React.FC<ProductDocsWidgetProps> = ({ title, description, topics }) => (
  <S.Root>
    {topics.map((topic) => {
      const section = sections.find((item) => item.label === topic);
      if (!section) return null;
      return (
        <DocsTopicSectionWidget
          key={section.key}
          section={section}
          title={topics.length === 1 ? title : `${title}: ${section.label}`}
          description={description}
          collapsible
          browseLinks={[
            {
              label: `Browse all ${topic === 'SECTOR' ? 'Sector' : topic} docs`,
              to: `/docs/topics/#${docsTopicSectionId(topic)}`
            }
          ]}
        />
      );
    })}
  </S.Root>
);

namespace S {
  export const Root = styled.div`
    padding-top: 64px;

    @media (max-width: ${PHONE_MEDIA}px) {
      padding-top: 40px;
    }
  `;
}
